/*
 * @Description: 版本路由
 * @Author: gao shuai
 * @Date: 2020-06-21 15:07:01
 * @LastEditTime: 2020-08-20 14:25:07
 * @LastEditors: gao shuai
 */

export const url = process.env.NODE_ENV !== 'production' ? 'http://192.168.1.80:5003' : 'http://tenantserver.tzmami.com'; // 接口的ip__zx固定
